import React from 'react'

// includes
import Dropdown from './Dropdown'

// icon
import { MdClear } from "react-icons/md";

export default function MenuContent(props) {
    // props
    const {
        categories,

        mobileMenuVisibility,
        setMobileMenuVisibility,
    } = props

    return (
        <div className="header-menu-inner">
            {
                /* overlay */
                mobileMenuVisibility ? (
                    <div className="menu-overlay d-lg-none d-flex" onClick={ev => {
                        ev.preventDefault()
                        setMobileMenuVisibility(false)
                    }}></div>
                ) : null
            }
            <div className={`nav-container-custom d-lg-flex flex-wrap justify-content-lg-center position-relative ${mobileMenuVisibility ? "active" : ""}`}>
                {/* icon */}
                <div className="cancel-icon d-lg-none pe-2 d-flex">
                    <div className="text-center ms-auto">
                        <MdClear className="icon st-fs-20 cursor-pointer d-lg-none" onClick={ev => {
                            ev.preventDefault()

                            setMobileMenuVisibility(false)
                        }} />
                        <span className="d-block st-fs-10 st-fw-600 text-uppercase">Close</span>
                    </div>
                </div>

                {
                    categories?.length ? categories.map((item, index) => {
                        return (
                            <Dropdown
                                key={item.category_id}
                                label={item.category_name}
                                catName={item.category_url}
                                menuItemIndex={index}
                                menuItem={item}

                                setMobileMenuVisibility={setMobileMenuVisibility}
                            />
                        );
                    }) : null
                }
            </div>
        </div>
    )
}
